import React, { useState } from "react";
import EditListButton from "./EditListButton";
import { LIST } from "./listStyle";

// CheckLister web components (CHECKLISTER_FULL_ENABLED on the back end).
//   checklistPicker  { purpose, title, options: [{ id, label, sublabel, disabled }] }
//                    every list / item / type choice, and the public lists
//                    ("(subscribed)" entries are shown but can't be tapped).
//   checklistView    { readOnly, list: { name, description, listType, items:
//                    [{ name, type, steps, description, author }] } }
//                    items with steps or a description open like an accordion.
// Choosing an option sends its id back as the next message; closing returns to
// chat ready for input. Shell mirrors ChatInfoModalsWeb.

function Shell({ onClose, title, children }) {
  return (
    <div style={LIST.backdrop} onClick={onClose}>
      <div role="dialog" aria-label={title} style={LIST.card} onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={onClose} aria-label="Close" style={LIST.close}>✕</button>
        <div style={LIST.title}>{title}</div>
        {children}
      </div>
    </div>
  );
}

export function ChecklistPickerWeb({ open, data, onPick, onClose }) {
  if (!open) return null;
  const options = Array.isArray(data?.options) ? data.options : [];
  return (
    <Shell onClose={onClose} title={data?.title || "Choose a checklist"}>
      <ul style={LIST.list}>
        {options.map((o) => (
          <li key={o.id}>
            <button type="button" disabled={!!o.disabled} onClick={() => onPick(o)}
              style={{ ...LIST.row, ...(o.disabled ? LIST.rowDisabled : {}), width: "100%", textAlign: "left", justifyContent: "space-between", cursor: o.disabled ? "not-allowed" : "pointer" }}>
              <span style={LIST.label}>{o.label}</span>
              {o.sublabel && <span style={LIST.sub}>{o.sublabel}</span>}
            </button>
          </li>
        ))}
      </ul>
      {data?.purpose === "subscribe" && <p style={{ margin: 0, color: "#777", fontSize: "12px" }}>Tap a list to subscribe. Lists you already follow are marked.</p>}
    </Shell>
  );
}

function Item({ item }) {
  const [openItem, setOpenItem] = useState(false);
  const more = (item.steps && item.steps.length) || item.description || item.author;
  return (
    <li style={{ ...LIST.row, padding: 0, display: "block" }}>
      <button type="button" onClick={() => more && setOpenItem((v) => !v)} aria-expanded={more ? openItem : undefined}
        style={{ width: "100%", textAlign: "left", display: "flex", alignItems: "center", gap: "10px", padding: "12px 14px", border: "none", background: "transparent", color: "inherit", fontSize: "14px", cursor: more ? "pointer" : "default" }}>
        <span style={{ fontSize: "16px" }}>☐</span>
        <span style={{ flex: 1 }}>{item.name || "(unnamed item)"}</span>
        {more ? <span aria-hidden="true" style={{ color: "#666" }}>{openItem ? "▾" : "▸"}</span> : null}
      </button>
      {more && openItem && (
        <div style={{ padding: "0 12px 10px 38px", fontSize: "13px", color: "#333" }}>
          {item.description && <p style={{ margin: "0 0 6px" }}>{item.description}</p>}
          {item.author && <p style={{ margin: "0 0 6px", color: "#666" }}>by {item.author}</p>}
          {item.steps && item.steps.length > 0 && (
            <ol style={{ margin: 0, paddingLeft: "18px" }}>{item.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
          )}
        </div>
      )}
    </li>
  );
}

export function ChecklistViewWeb({ open, data, onClose, onEdit }) {
  if (!open) return null;
  const list = data?.list || {};
  const items = Array.isArray(list.items) ? list.items : [];
  return (
    <Shell onClose={onClose} title={list.name || "My checklist"}>
      {list.description && <p style={{ margin: 0, color: "#333", fontSize: "14px" }}>{list.description}</p>}
      {items.length ? (
        <ul style={LIST.list}>
          {items.map((it, i) => <Item key={i} item={it} />)}
        </ul>
      ) : <p style={LIST.empty}>No items yet.</p>}
      <p style={{ margin: 0, color: "#777", fontSize: "12px" }}>
        {data?.readOnly ? "You subscribe to this list, so it is view-only." : "Say \"add item to my checklist\" or \"edit my checklist\" to change it."}
      </p>
      {/* Edit (25 Oct): the existing "edit my checklist" flow; not on view-only lists. */}
      {onEdit && !data?.readOnly && <EditListButton onClick={onEdit} />}
      <button type="button" onClick={onClose}
        style={{ alignSelf: "center", padding: "12px 32px", background: "blue", color: "#fff", border: "none", borderRadius: "10px", fontWeight: 600, cursor: "pointer" }}>Done</button>
    </Shell>
  );
}
